import { createContext, useContext, useState, type ReactNode } from 'react';

interface AssistantMessageContextValue {
  isDetailsDialogOpen: boolean;
  setIsDetailsDialogOpen: (open: boolean) => void;
}

const AssistantMessageContext = createContext<AssistantMessageContextValue | null>(null);

export interface AssistantMessageProviderProps {
  children: ReactNode;
}

export function AssistantMessageProvider({ children }: AssistantMessageProviderProps) {
  const [isDetailsDialogOpen, setIsDetailsDialogOpen] = useState(false);

  return (
    <AssistantMessageContext.Provider
      value={{
        isDetailsDialogOpen,
        setIsDetailsDialogOpen,
      }}
    >
      {children}
    </AssistantMessageContext.Provider>
  );
}

export function useAssistantMessage() {
  const context = useContext(AssistantMessageContext);

  if (!context) {
    throw new Error('useAssistantMessage must be used within AssistantMessageProvider');
  }

  return context;
}

export function useDetailsDialog() {
  const { isDetailsDialogOpen, setIsDetailsDialogOpen } = useAssistantMessage();

  const openDetailsDialog = (id?: string) => {
    if (typeof id === 'string') {
      history.replaceState(null, '', `#${id}`);
    }

    setIsDetailsDialogOpen(true);
  };

  const closeDetailsDialog = () => {
    history.replaceState(null, '', window.location.pathname + window.location.search);

    setIsDetailsDialogOpen(false);
  };

  return {
    isDetailsDialogOpen,
    openDetailsDialog,
    closeDetailsDialog,
  };
}
